export default __webpack_public_path__ + "previewComponent.png";